import { createModule } from 'saga-slice';
import { loadingReducer, failReducer } from 'saga-slice-helpers';
import { takeLatest } from 'redux-saga/effects';
import { sagaApi } from '#/apis';
import { mapToId } from '#/meta';

const sagaSlice = createModule({

    name: 'employees',
    initialState: {
        isFetching: false,
        data: {},
        error: null
    },

    reducers: {
        create: loadingReducer,
        createSuccess: (state, payload) => {
            state.data[payload.id] = payload;
            state.isFetching = false;
        },
        readOne: loadingReducer,
        readOneByDepartment: loadingReducer,
        readOneSuccess: (state, payload) => {
            state.data[payload.id] = payload;
            state.isFetching = false;
        },
        readAll: loadingReducer,
        readAllSuccess: (state, payload) => {
            state.data = mapToId(payload);
            state.isFetching = false;
        },
        updateOne: loadingReducer,
        updateOneSuccess: (state, payload) => {
            state.data[payload.id] = payload;
            state.isFetching = false;
        },
        delete: loadingReducer,
        deleteSuccess: (state, payload) => {
            delete state.data[payload.id];
            state.isFetching = false;
        },

        failReducer

    },

    sagas: A => ({
        [A.create]: {
            *saga ({ payload }) {

                yield sagaApi.post('/employees', payload, A.createSuccess, A.failReducer);
            }
        },
        [A.delete]: {
            *saga ({ payload: id }) {

                yield sagaApi.delete(`/employees/${id}`, null, A.deleteSuccess, A.failReducer);
            }
        },
        [A.updateOne]: {
            *saga ({ payload }) {

                yield sagaApi.put(`/employees/${payload.id}`, payload, A.updateOneSuccess, A.failReducer);
            }
        },
        [A.readOne]: {
            *saga ({ payload: id }) {
                yield sagaApi.get(`/employees/${id}`, A.readOneSuccess, A.failReducer);
            }
        },
        [A.readOneByDepartment]: {
            *saga ({ payload }) {
                yield sagaApi.get(`/departments/${payload.department_id}/employees/${payload.employee_id}`, A.readOneSuccess, A.failReducer);
            }
        },
        [A.readAll]: {
            *saga () {

                yield sagaApi.get('/employees', A.readAllSuccess, A.failReducer);
            },
            taker: takeLatest
        }
    })
});

// Export actions for convenience when importing from other modules
export const { actions } = sagaSlice;
export default sagaSlice;
